import React,  { useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { useMediaQuery } from '@material-ui/core'
import { Button } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { isMobile } from 'react-device-detect'

import useStyles from './styles'
//import mapStyles from './mapStyles'
import {pinStyle} from './pin_style'
import {selectedPinStyle} from './pin_style_selected'

import Pin_Disposal from '../../images/Icon_Disposal.png'
import Pin_HealthClinic from '../../images/Icon_HealthClinic.png'
import Pin_HIV from '../../images/Icon_HIV.png'
import Pin_Pharmacy from '../../images/Icon_Pharmacy.png'
import Pin_Recovery from '../../images/Icon_Recovery.png'
import Pin_Syringe from '../../images/Icon_Syringe.png'

import CategorySelection from './CategorySelection'

function categoryToPin(category, placeCategory1) {

    if(category === "View All") {
        category = placeCategory1
    }

    if(category.includes("Pharmacy")) {
        return Pin_Pharmacy;
    }
    else if(category.includes("Substance Use Disorder Treatment")) {
        return Pin_Recovery;
    }
    else if(category.includes("Sharps Disposal")) {
        return Pin_Disposal;
    }
    else if(category.includes("Health Clinic")) {
        return Pin_HealthClinic;
    }
    else if(category.includes("HIV Services")) {
        return Pin_HIV;
    }
    else if(category.includes("Syringe Exchange")) {
        return Pin_Syringe;
    }

    switch(category) {
        case "Pharmacy":
            return Pin_Pharmacy;
        case "Substance Use Disorder Treatment":
            return Pin_Recovery;
        case "Sharps Disposal":
            return Pin_Disposal;
        case "Health Clinic":
            return Pin_HealthClinic;
        case "HIV Services":
            return Pin_HIV;
        case "Syringe Exchange":
            return Pin_Syringe;
    }
    return Pin_HealthClinic
}

const Map = ({ type, setType, setCoordinates, setMapSize, updateData, setZoom, coordinates, places, setChildClicked, childClicked, category, setMap, setMaps, addingCustomLocation, setCustomLocationCoordinates }) => {
    const classes = useStyles()
    const isDesktop = useMediaQuery('(min-width:600px)')

    const [mapWidth, setMapWidth] = useState(0)
    const [promptUpdate, setPromptUpdate] = useState(false)


    const handleApiLoaded = (map, maps) => {
        setMap(map)
        setMaps(maps)
    };

    function handleMapClick(event) {
        setCustomLocationCoordinates({lat: event.lat, lng: event.lng})
    }

    return (
        <div className={classes.mapContainer}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, libraries:['places'] }}
                defaultCenter={coordinates}
                center={coordinates}
                defaultZoom={14}
                margin={[50, 50, 50, 50]}
                options={{ disableDefaultUI: true, zoomControl: (isMobile ? false : true), gestureHandling: 'greedy'/*, styles: mapStyles*/ }}
                onChange={(e) => {
                    setCoordinates({ lat: e.center.lat, lng: e.center.lng });
                    setMapSize({ width: e.size.width, height: e.size.height });
                    setZoom(e.zoom)
                    setMapWidth(e.size.width)
                    setPromptUpdate(true)
                }}
                onChildClick={(child) => {
                    setChildClicked(child)
                }}
                onClick={handleMapClick}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            >
                {places?.map((place, i) => (
                    <div
                        className={classes.markerContainer}
                        lat={Number(place.lat)}
                        lng={Number(place.lng)}
                        key={i}
                    >
                        <img style={i == childClicked ? (selectedPinStyle) : (pinStyle)} alt={place.name} src={categoryToPin(category, place.category1)} />
                    </div>
                ))}
            </GoogleMapReact>
            {addingCustomLocation && (
                <div
                    style={{
                        position: 'absolute',//use absolute position to show button on top of the map
                        top: '75px', //for center align
                        left: ((mapWidth * 0.5) - 160),
                    }}
                >
                    <Button  variant="contained" color="secondary">
                        Click the map to add a new location
                    </Button>
                </div>
            )}
            {(promptUpdate && !addingCustomLocation) && (
                <div
                    style={{
                        position: 'absolute',//use absolute position to show button on top of the map
                        top: '75px', //for center align
                        left: ((mapWidth * 0.5) - 95),
                    }}
                >
                    <Button variant="contained" startIcon={<SearchIcon />} onClick={() => {
                        setPromptUpdate(false)
                        updateData()
                    }}>
                        Search this Area
                    </Button>
                </div>
            )}
            <div style={{
                position: 'absolute',
                bottom: 15,
                left: ((mapWidth * 0.5) - 160),
            }}>
                <CategorySelection type={type} setType={setType} />
            </div>
        </div>
    )
}

export default Map